const togglePassword = document.querySelector(".togglePassword");

if(togglePassword) {
    const password = document.querySelector("#" + togglePassword.getAttribute('for'));

    togglePassword.addEventListener("click", function () {
        // toggle the type attribute
        const type = password.getAttribute("type") === "password" ? "text" : "password";
        password.setAttribute("type", type);
        
        // toggle the icon
        this.classList.toggle("bi-eye");
    });
}